import type { Item } from './types';

const registry = new Map<string, Item>();

/**
 * Register an item in the global registry.
 * Throws Error if an item with the same id is already registered.
 */
export function addItem(item: Item): void {
  if (registry.has(item.id)) {
    throw new Error(`Item with id "${item.id}" is already registered`);
  }
  registry.set(item.id, item);
}

/**
 * Retrieve an item by id.
 * Returns undefined if the item does not exist.
 */
export function getItem(id: string): Item | undefined {
  return registry.get(id);
}

/**
 * Return a read-only snapshot of all registered items.
 */
export function allItems(): readonly Item[] {
  return Array.from(registry.values());
}

/**
 * Check if an item with the given id has category === 'armory'.
 */
export function isArmory(id: string): boolean {
  return registry.get(id)?.category === 'armory';
}

/**
 * Remove an item from the registry by id.
 * Test-only helper; used to clean up stub test items.
 */
export function removeItem(id: string): void {
  registry.delete(id);
}

/**
 * Clear all registered items.
 * Test-only helper; used between test runs.
 */
export function resetRegistry(): void {
  registry.clear();
}
